import dayjs from '@tt/dates/dayjs';

export const ASSET_OPTIONS = [
    { label: 'Stocks', value: 'Stock' },
    { label: 'Options', value: 'Option' },
    { label: 'Future', value: 'Future' },
    { label: 'Cash', value: 'Cash' }
];

export const BASIC_MEASURE_OPTIONS = [
    {
        key: 'Dollar',
        label: 'Dollar',
        value: 'Dollar'
    },
    {
        key: 'R-multiple',
        label: 'R-multiple',
        value: 'R-multiple'
    }
];

export const RANGE_PRESETS = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 3 Months', value: [dayjs().add(-3, 'M'), dayjs()] },
    { label: 'Last 6 Months', value: [dayjs().add(-6, 'M'), dayjs()] },
    { label: 'Last 12 Months', value: [dayjs().add(-12, 'M'), dayjs()] },
    { label: 'Last 5 Years', value: [dayjs().add(-5, 'y'), dayjs()] }
];

export const SIDES = ['Long', 'Short'];
export const STATUSES = ['Open', 'Closed'];

export const STRATEGY_SET_TYPE_OPTIONS = [
    { label: 'All Sets', value: null },
    { label: 'Strategy (Disciplined)', value: 'strategy' },
    { label: 'No Strategy (Undisciplined)', value: 'noStrategy' }
];

export const COMPANY_ACCOUNT_FILTERS = {
    'Bear Bull Traders': (account) => account.ptt_account && account.ptt_account !== '',
    'Peak Capital Trading': (account) => account.pct_account && account.pct_account !== '',
    'Trading Terminal': (account) => account.simulator_account && account.simulator_account !== '',
    Personal: (account) => account.liveAccount === false
};
